import styled from 'styled-components';

export const SwiperBox = styled.div<{ $noImageSrc?: string }>`
  position: relative;
  height: 100%;
  overflow: hidden;
  background-image: ${({ $noImageSrc }) => ($noImageSrc ? `url(${$noImageSrc})` : 'none')};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #eeeeee;

  .gallery-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .custom-prev,
  .custom-next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    border-radius: 4px;
    width: 28px;
    height: 28px;
    cursor: pointer;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    z-index: 10;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #151b2850 !important;
    color: white;
    font-size: 24px;
  }

  .custom-prev span,
  .custom-next span {
    display: block;
    width: fit-content;
  }

  .custom-prev:hover,
  .custom-next:hover,
  .custom-pagination:hover {
    background: #151b2870 !important;
  }

  .custom-prev.swiper-button-disabled,
  .custom-next.swiper-button-disabled {
    display: none;
  }

  .custom-prev {
    left: 8px;
  }
  .custom-next {
    right: 8px;
  }

  .custom-pagination {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 0px;
    width: fit-content;
    z-index: 10;
    padding: 4px 6px;
    background: #151b2850 !important;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  .custom-pagination .swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    background: white;
    opacity: 0.6;
    border-radius: 50%;
    cursor: pointer;
  }

  .custom-pagination .swiper-pagination-bullet-active {
    opacity: 1;
    background: white;
    transform: scale(1.1);
  }

  .gallery-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
`;
